export const estado = {
  ACTIVO: true,
  INACTIVO: false,
}
